<template>
  <div class="container-pay" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop: ${topBarHeight}px`">
      <van-nav-bar class="van-bar" left-trangle @click-left="goBack" @click-right="goCustomer">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <span class="tit-left">{{ $t('lang.PayNext.k001') }}</span>
        </template>

        <template #right>
          <img class="icon-right" src="@/assets/packageAssets/views/P1_Boys/PayNext/default/customer.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <div class="pay">
        <div class="money-block">
          <img class="moneys" :src="getMatchImg('coin')" alt="" />
          <div class="amount">{{ myPlus(amount, presentAmount) }}</div>
        </div>
        <div class="pay-other">
          <template v-for="item in presentPropList">
            <div v-if="item.propType == 1" class="dis-item">
              <img :src="getMatchImg('chat-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 2" class="dis-item">
              <img :src="getMatchImg('video-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 4" class="dis-item">
              <img :src="getMatchImg('vip')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 6" class="dis-item">
              <img :src="getMatchImg('call-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 9" class="dis-item">
              <img :src="getMatchImg('coupon')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 15" class="dis-item">
              <img :src="getMatchImg('super-chat-pass')" />
              x{{ item.number }}
            </div>
          </template>
        </div>
      </div>

      <div class="coupons-block">
        <!-- 优惠券入口 -->
        <div :class="{ 'show-item': true, 'color-border': showCoupons }" @click="handleClickCouponEnter">
          <!-- 有可用优惠券 -->
          <template v-if="selectedCoupon">
            <div class="coupon-logo">
              <img :src="getMatchImg('coupon')" />
              <span>{{ $t('lang.BaseCommon.k038') }}</span>
            </div>

            <div class="coupon-info">
              <MyPLabel
                class="info-main"
                :str="`${$t('lang.BaseCommon.k030')} #coin# ${selectedCoupon.amount}`"
                :customClass="{ coin: 'pay-coin-icon' }"
              />
            </div>
          </template>
          <!-- 无可用优惠券 -->
          <template v-else>
            <div class="coupon-logo">
              <img :src="getMatchImg('coupon-off')" />
              <span class="no-valid-info">{{ $t('lang.BaseCommon.k064') }}</span>
            </div>
            <div class="coupon-info"></div>
          </template>
          <div class="coupon-arrow" :class="[showCoupons ? 'arrow-up' : '']"></div>
        </div>

        <!-- 优惠券列表 -->
        <div v-if="showCoupons" class="coupon-scroll">
          <div
            v-for="item in validCouponList"
            :key="item.couponRecordId"
            :class="{ 'coupon-item': true, 'coupon-acitve': selectedCoupon && item.couponRecordId === selectedCoupon.couponRecordId }"
            @click="handleSelectCoupon(item)"
          >
            <!-- 可用 -->
            <div v-if="item.canUse === true" class="coupon-con">
              <div class="coupon-info">
                <MyPLabel class="info-main" :str="item.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
              </div>
            </div>
            <!-- 无用 -->
            <div v-else class="coupon-con no-valid-coupon">
              <div class="coupon-info">
                <MyPLabel class="info-main" :str="item.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
              </div>
            </div>

            <div v-if="selectedCoupon && item.couponRecordId === selectedCoupon.couponRecordId" class="coupon-check checked"></div>
            <div v-else class="coupon-check not-checked"></div>
          </div>
        </div>
      </div>

      <!-- Methods -->
      <div class="block-title">
        <div>{{ $t('lang.PayNext.k004') }}</div>
      </div>

      <div v-if="googlePrice" :class="['method-item', selectedIndex === 9999 ? 'method-on' : '']" @click.prevent="selectOriginPay">
        <div class="method-check" :class="[selectedIndex === 9999 ? 'checked' : '']"></div>
        <div :class="['method-con', hasGooglePayMarks() ? 'has-marks' : 'is-compact']">
          <div class="method-img">
            <img v-if="env.isAppIOS" src="@/assets/packageAssets/common/apple_pay.webp" alt="" />
            <img v-else src="@/assets/packageAssets/common/google.webp" alt="" />
          </div>
          <div class="method-name">
            <div v-if="env.isAppIOS" class="method-info">
              <span class="name">Apple Pay</span>
              <div v-if="lastUsedChannel == 'Apple Pay'" class="method-mark-container">
                <div class="method-mark last-used">{{ $t('lang.PayNext.k007') }}</div>
              </div>
            </div>

            <div v-else class="method-info">
              <span class="name">Google Pay</span>
              <div v-if="lastUsedChannel == 'Google Pay'" class="method-mark-container">
                <div class="method-mark last-used">{{ $t('lang.PayNext.k007') }}</div>
              </div>
            </div>

            <!-- 符号与金额不匹配问题-兼容 -->
            <div v-if="googleCurrencyPrice" class="rate">{{ googleCurrencyPrice }}</div>
            <div v-else class="rate">{{ googleCurrency }} {{ googlePrice }}</div>
          </div>
        </div>
      </div>

      <div v-for="(item, index) in payList" :key="index" class="pay-method-cell">
        <div
          :class="['method-item', item.ifBestPrice === true ? 'best-type' : '', index === selectedIndex ? 'method-on' : '']"
          @click.prevent="handleSelectPay(item, index)"
        >
          <div class="method-check" :class="[index === selectedIndex ? 'checked' : '']"></div>
          <div :class="['method-con', hasMethodMarks(item) ? 'has-marks' : 'is-compact']">
            <div class="method-img"><img :src="item.icon | imgPath" alt="" /></div>
            <div class="method-name" v-if="item.icon">
              <div class="method-info">
                <div class="name">{{ item.name }}</div>
                <div v-if="hasMethodMarks(item)" class="method-mark-container">
                  <div v-if="item.label" class="method-mark discount">
                    {{ item.label }}
                  </div>
                  <div v-if="showLastUsedMark(item)" class="method-mark last-used">{{ $t('lang.PayNext.k007') }}</div>
                  <MyPLabel
                    v-if="showMostPopularMark(item)"
                    class="method-mark most-favorable"
                    :str="$t('lang.PayNext.k005')"
                    :customClass="{ coin: 'pay-coin-icon' }"
                  />
                  <div v-if="item.tipType === 3" class="method-mark discount-first-use">{{ $t('lang.PayNext.k014') }}</div>
                </div>
              </div>
              <div class="rate">{{ item.currency }} {{ handleDiv100(item.price) }}</div>
            </div>
          </div>
        </div>
        <div v-if="item.tipType === 1 || item.tipType === 2" :class="'method-tip-section'" @click.stop="toggleTip(index)">
          <div class="tip-header">
            <span class="tip-title">👉🏻 {{ $t('lang.PayNext.k008') }}</span>
            <div class="tip-arrow" :class="[tipExpandMap[index] ? 'arrow-up' : '']"></div>
          </div>
          <template v-if="tipExpandMap[index]">
            <div v-if="item.tipType === 1" class="tip-body">
              <div>{{ $t('lang.PayNext.k009') }}</div>
              <div>{{ $t('lang.PayNext.k010') }}</div>
              <div>{{ $t('lang.PayNext.k011') }}</div>
            </div>
            <div v-else-if="item.tipType === 2" class="tip-body">
              <div>{{ $t('lang.PayNext.k012') }}</div>
              <div>{{ $t('lang.PayNext.k013') }}</div>
            </div>
          </template>
        </div>
      </div>

      <!-- 底部栏占位用 -->
      <div style="width: 100%; height: 300px"></div>

      <div class="submit-btn-block">
        <!-- prettier-ignore -->
        <div class="submit-btn" @click="handleClickPay">
          {{ $t('lang.BaseCommon.k040') }} {{ submitBtnCoinTotal }} <img :src="getMatchImg('coin')" />
          <template v-if="selectedItem">
            <template v-if="selectedItem.currencyPrice">({{selectedItem.currencyPrice}})</template>
            <template v-else>({{selectedItem.currency}}&nbsp;{{handleDiv100(selectedItem.price)}})</template>
          </template>
          <van-loading v-if="loadingShow" type="spinner" color="#ffffff" class="pay-loading" size="20px" />
        </div>
        <div :style="{ height: `${bottomBarHeight || 30}px` }"></div>
      </div>
    </div>

    <!-- 支付结果弹窗 -->
    <PayResult :showDiaC="showResultDia" :oneShow="true" :title="payResultText" />
  </div>
</template>

<script>
// 多包样式
import { pageCssVars } from '@/views/P1_Boys/PayNext/z-style-cfg.js'

import { apiFetchPayList, apiFetchShopOrder } from '@/api/imee'
import { mixin } from './base.mixin.js'

import _debounce from 'lodash/debounce'

import PayResult from '@/components/CConfirm/PayResult.vue'

function strToNum(str) {
  let result = null
  if (str) {
    // prettier-ignore
    try {
      result = str * 1
    } catch (err) {
      result = null
    }
  }
  return result
}

export default {
  mixins: [pageCssVars, mixin],
  components: { PayResult },
  data() {
    const query = this.$route.query
    return {
      // 产品信息
      gid: query.gid || null,
      productId: null,

      // 优惠信息
      amount: 0,
      presentAmount: 0,
      presentPropList: [],

      // 方式-三方
      lastUsedChannel: '',
      payList: [],
      payListReady: false,
      selectedIndex: -1,
      selectedItem: null,

      // 方式-google/apple
      googlePrice: query.price || null,
      googleCurrency: query.currency || null,
      googleCurrencyPrice: query.currencyPrice || null,

      // 控制参数-提示loading
      loadingShow: false,

      // 支付方式统计
      selectChannelIndex: -1,

      // 提示语展开状态
      tipExpandMap: {},
    }
  },
  watch: {
    googlePrice() {
      this.applyGooglePricePaySelection()
    },
    payListReady(val) {
      if (val) {
        this.applyGooglePricePaySelection()
      }
    },
  },
  computed: {
    /** 支付按钮展示金币：基础 amount + presentAmount + 已选优惠券 amount */
    submitBtnCoinTotal() {
      const couponAmount = this.selectedCoupon && this.selectedCoupon.amount != null ? this.selectedCoupon.amount : 0
      return this.myPlus(this.myPlus(this.amount, this.presentAmount), couponAmount)
    },
  },
  methods: {
    showMostPopularMark(item) {
      return !!(item && item.ifBestPrice === true && !item.lastUsed)
    },
    showLastUsedMark(item) {
      return !!(item && item.lastUsed)
    },
    hasMethodMarks(item) {
      if (!item) return false
      if (item.tipType === 3) return true
      if (this.showMostPopularMark(item) || this.showLastUsedMark(item)) return true
      return !!(item.label && String(item.label).trim())
    },
    hasGooglePayMarks() {
      if (this.env.isAppIOS) {
        return this.lastUsedChannel === 'Apple Pay'
      }
      return this.lastUsedChannel === 'Google Pay'
    },
    applyGooglePricePaySelection() {
      if (!this.payListReady || !this.googlePrice) return
      try {
        // 土耳其的
        if (this.payList.length && this.payList[0].currency === 'TL') {
          const cardIndex = this.payList.findIndex((item) => item.name === 'Card Payments')
          if (cardIndex > -1) {
            this.handleSelectPay(this.payList[cardIndex], cardIndex)
          } else {
            this.selectOriginPay()
          }
        } else {
          this.selectOriginPay()
        }
      } catch (err) {
        console.log('try catch err:', err)
      }
    },
    resolveDefaultPayWithoutGoogle() {
      if (this.payList.length && this.payList[0].currency === 'TL') {
        const cardIndex = this.payList.findIndex((item) => item.name === 'Card Payments')
        if (cardIndex > -1) {
          this.handleSelectPay(this.payList[cardIndex], cardIndex)
        } else {
          this.selectedBestPayType()
        }
      } else {
        this.selectedBestPayType()
      }
    },
    fetchPayList() {
      if (!this.gid) {
        return
      }

      const resolvePayList = (res, fromApi) => {
        this.productId = res.productId
        this.amount = res.amount || 0
        this.presentAmount = res.presentAmount || 0
        this.presentPropList = res.presentPropListV2 || []
        this.lastUsedChannel = res.lastUsedChannel
        this.payList = res.payChannelList || []
        this.payListReady = true

        // 渲染缓存数据，不处理优惠券
        fromApi && this.initCoupon()

        this.sortPayType()

        if (this.googlePrice) {
          this.applyGooglePricePaySelection()
        } else {
          this.resolveDefaultPayWithoutGoogle()
        }
      }

      // 读取web localstorage缓存
      const uid = this.getUid() || 'unknown'
      const localRes = window.localStorage.getItem(`payList_${uid}_${this.gid}`)
      if (this.gid && localRes) {
        resolvePayList(JSON.parse(localRes))
      }

      apiFetchPayList({
        gid: this.gid,
        activityType: this.$route.query.activityType,
        tierId: this.$route.query.tierId || null,
        shopType: this.getShopType(),
      }).then((res) => {
        if (res && res.payChannelList) {
          // 写入web localstorage缓存
          window.localStorage.setItem(`payList_${uid}_${this.gid}`, JSON.stringify(res))

          resolvePayList(res, true)
        }
      })
    },

    queryGoogleProductListCallback(res) {
      if (res) {
        try {
          const googlePayList = JSON.parse(res)
          const targetItem = googlePayList.find((item) => {
            return this.$route.query.productId == item.productId
          })
          if (targetItem) {
            this.googlePrice = targetItem.price
            this.googleCurrency = targetItem.currencyCode
            this.googleCurrencyPrice = targetItem.currencyPrice
          }
        } catch (err) {
          console.log('try catch err:', err)
        }
      }
    },

    handleSelectPay(item, index) {
      this.selectedItem = item
      this.selectedIndex = index
    },

    toggleTip(index) {
      this.$set(this.tipExpandMap, index, !this.tipExpandMap[index])
    },

    handleClickPay: _debounce(
      function () {
        if (this.selectedIndex > -1) {
          const tempKeys = Object.keys(this.selectedItem)
          // thirdpay
          if (tempKeys && tempKeys.length && this.selectedIndex !== 9999) {
            this.thirdPay(this.selectedItem)
          }
          // googlpay/applepay
          else {
            this.originPay()
          }
        }
      },
      500,
      {
        leading: true,
        trailing: false,
      }
    ),

    thirdPay: _debounce(
      function (item) {
        let payChannelTotal = null
        if (this.payList && this.payList.length) {
          payChannelTotal = this.payList.length
        }
        let payChannelIndex = null
        if (this.selectChannelIndex != -1 && payChannelTotal !== null && payChannelTotal !== 0) {
          payChannelIndex = payChannelTotal - 1 - this.selectChannelIndex
        }
        if (this.googlePrice && this.googleCurrency && payChannelTotal !== null && payChannelIndex !== null) {
          payChannelTotal = payChannelTotal + 1
          payChannelIndex = payChannelIndex + 1
        }

        const data = {
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null,
          gid: this.gid,
          payType: item.payType,
          scene: this.scene,
          thirdParam: this.thirdParam,
          payChannel: item.name,
          payChannelIndex: payChannelIndex,
          payChannelTotal: payChannelTotal,
        }
        if (this.$route.query.videoChatScene) {
          data.videoChatScene = this.$route.query.videoChatScene
        }
        if (this.$route.query.activityType) {
          data.activityType = this.$route.query.activityType
        }
        if (this.selectedCoupon && this.scene != 'activity') {
          data.couponRecordId = this.selectedCoupon.couponRecordId
        }
        if (this.scene == 'activity') {
          data.shopType = 7
        }
        this.$client.addEvent('top_up', {
          Action: 'Click',
          APosition: 'payButton',
          productID: this.productId,
          goodtype: 'coin',
          from: 'cash',
          paymethod: item.name,
        })

        if (this.loadingShow === true) {
          return
        }

        this.loadingShow = true

        apiFetchShopOrder(data)
          .then((res) => {
            // 下单后刷新优惠券
            this.initCoupon()

            if (res && !res.error) {
              const openInExternalBrowser = res.credential?.openInExternalBrowser || false
              const wapUrl = res.credential?.wapUrl || ''
              // 外部浏览器打开
              if (openInExternalBrowser) {
                this.appAction('open_web_outside', `?url=${wapUrl}`)

                // 调用三方支付后，无法检测支付状态，直接关闭web
                if (['10', '18', '19', '27'].includes(this.$route.query.activityType)) {
                  this.closeWeb()
                }
              }
              // webview打开
              else {
                if (wapUrl) {
                  this.$router.push({
                    path: '/pay-code',
                    query: { url: wapUrl },
                  })
                }
              }
            }
          })
          .finally(() => {
            this.loadingShow = false
          })
      },
      2000,
      {
        leading: true,
        trailing: false,
      }
    ),

    originPay() {
      // 从 h5 活动页进入，客户端不知道商品信息，不知道优惠券信息
      if (this.$route.query.useWebPay == '1') {
        const params = {
          gid: this.gid,
          productId: this.$route.query.productId || '',
          activityType: this.$route.query.activityType * 1,
          scene: this.$route.query.scene || '',
          tierId: strToNum(this.$route.query.tierId),
          shopType: this.$route.query.shopType || null,
        }

        // echo
        if (this.packageName === 'echo') {
          nativePaymentFromWeb.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogleFromWeb.postMessage(JSON.stringify(params))
        }

        // 客户端原生支付成功后，web可以监听window.refresh
        // 回到上级活动页面，后续逻辑由活动页面处理
        if (['10', '18', '19', '27'].includes(this.$route.query.activityType)) {
          this.goPrevious()
        }
      }
      // 从客户端商品列表进入，客户端知道商品信息，不知道优惠券信息
      else {
        const params = {
          tierId: strToNum(this.$route.query.tierId),
          shopType: this.$route.query.shopType || null,
          extendPay: this.$route.query.extendPay || null,
        }

        if (this.selectedCoupon) {
          params.couponRecordId = this.selectedCoupon.couponRecordId
        }

        // echo
        if (this.packageName === 'echo') {
          nativePayment.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogle.postMessage(JSON.stringify(params))
        }
      }
    },

    // 原生支付完成后，客户端调用window.refresh
    refresh() {
      // 从活动页面进入
      if (this.$route.query.useWebPay == '1') {
        this.init()
      }
      // 从客户端进入
      else {
        this.closeWeb()
      }
    },

    init() {
      this.fetchPayList()
    },
  },
  created() {
    this.init()

    // 客户端回调刷新
    window.refresh = this.refresh

    // 获取客户端原生支付
    if (this.packageName === 'echo') {
      window.queryProductListCallback = this.queryGoogleProductListCallback
    }
    //
    else {
      window.queryGoogleProductListCallback = this.queryGoogleProductListCallback
    }

    if (this.$route.query.productId) {
      this.$client.googleProductList([this.$route.query.productId], this.packageName)
    }
  },
}
</script>
<style lang="scss" scoped>
.container-pay {
  width: 100%;
  min-height: 100vh;
  background: var(--pay-bg01, #f9f9fb);

  .custom-nav-block {
    background-color: var(--pay-bg01, #f9f9fb);

    .tit-left {
      line-height: var(--lh-title-20);
      color: var(--pay-color00, #333333);
    }

    .icon-right {
      box-sizing: content-box;
      width: 25px;
      height: 25px;
    }
  }

  .main {
    padding: 20px 16px;
  }

  .pay {
    width: 100%;
    .money-block {
      display: flex;
      align-items: center;
      justify-content: center;

      font-family: var(--string-font);

      .moneys {
        width: 38px;
        height: 38px;
      }
      .amount {
        font-family: var(--number-font, 'Inter-Regular');
        font-size: var(--fs-32);
        font-weight: var(--fw-600);
        line-height: var(--lh-display-40);
        color: var(--pay-color01, #333333);
      }
    }
    .pay-other {
      margin-top: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 16px;

      .dis-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        font-family: var(--number-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-400);
        line-height: var(--lh-label-18);
        color: var(--pay-color04, #666666);

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
    .tips-one {
      width: 343px;
      margin: 8px auto 0;

      font-family: var(--string-font);
      font-size: var(--fs-12);
      font-weight: var(--fw-400);
      line-height: var(--lh-label-18);
      color: var(--pay-color05, #b2b2b2);
    }
  }

  .block-title {
    display: flex;
    align-items: flex-start;
    margin-top: 20px;
    div {
      &:nth-child(1) {
        width: 100%;
        font-family: var(--string-font);
        font-size: var(--fs-20);
        font-weight: var(--fw-400);
        line-height: var(--lh-title-20);
        color: var(--pay-color06, #333333);
      }
    }
  }

  .coupons-block {
    margin: 16px auto 0;
    background: var(--pay-bg02, #fefefe);
    border-radius: 8px;
    overflow: visible;
    position: relative;

    .show-item {
      position: relative;
      z-index: 2;
      padding: 12px;
      display: flex;
      align-items: center;
      border-radius: 8px;
      background: var(--pay-bg02, #fefefe);
      .coupon-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        > img {
          width: 24px;
          height: 24px;
          margin: 0 4px;
        }
        > span {
          font-family: var(--string-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-400);
          line-height: var(--lh-body-20);
          color: var(--pay-color08, #666666);
        }
        span.no-valid-info {
          color: var(--pay-color16, #b2b2b2);
        }
      }

      .coupon-info {
        flex: 1;
        margin: 0 4px;
        .info-main {
          font-family: var(--number-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-400);
          line-height: var(--lh-body-20);
          color: var(--pay-color08, #666666);

          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }

      .coupon-arrow {
        width: 24px;
        height: 24px;
        background: var(--pay-icon01) top left / 100% 100% no-repeat;
        transform: rotateZ(0deg);
        &.arrow-up {
          transform: rotateZ(180deg);
        }
      }
    }

    .coupon-scroll {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 999;
      width: 100%;
      transform: translateY(102%);
      border-radius: 8px;
      background-color: var(--pay-bg03, #ffffff);
      box-shadow: 0 4px 8px 0 rgba(79, 82, 90, 0.25);
      max-height: 190px;
      padding-bottom: 5px;
      overflow-y: auto;

      .coupon-item {
        padding: 16px;
        margin: 4px 4px 0 4px;
        display: flex;
        align-items: center;
        border-radius: 8px;
        .coupon-check {
          width: 16px;
          height: 16px;
          &.checked {
            background: var(--pay-icon02) top left / 100% 100% no-repeat;
          }
          &.not-checked {
            background: var(--pay-icon03) top left / 100% 100% no-repeat;
          }
        }
        .coupon-con {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 0 5px;
          .coupon {
            width: 20px;
            margin: 0 4px;
          }
          .coupon-info {
            .info-main {
              font-family: var(--number-font, 'Inter-Regular');
              font-size: var(--fs-16);
              font-weight: var(--fw-500);
              line-height: var(--lh-label-18);
              font-style: normal;
              color: var(--pay-color08, #666666);
            }
          }
        }
        .no-valid-coupon {
          .coupon-info {
            .info-main {
              color: var(--pay-color16, #b2b2b2);
            }
          }
        }
        .coupon-arrow {
          width: 24px;
          height: 24px;
          background: var(--pay-icon01) top left / 100% 100% no-repeat;
          transform: rotateZ(0deg);
          &.arrow-up {
            transform: rotateZ(180deg);
          }
        }
      }

      .coupon-acitve {
        background: var(--pay-bg04, #f4f5f7);
      }
    }
  }

  .pay-method-cell {
    position: relative;
    isolation: isolate;

    > .method-item {
      position: relative;
      z-index: 2;
    }

    .method-tip-section {
      position: relative;
      z-index: 1;
    }
  }

  .method-item {
    width: 100%;
    margin-top: 12px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 0 1.5px 0 transparent inset;
    background: var(--pay-bg03, #ffffff);
    position: relative;
    overflow: hidden;

    .method-check {
      position: absolute;
      top: 0;
      right: 0;
      width: 28px;
      height: 28px;
      &.checked {
        background: var(--pay-icon04) top left / 100% 100% no-repeat;
      }
    }

    .method-con {
      display: flex;
      width: 100%;
      padding: 12px;

      &.is-compact {
        align-items: center;

        .method-name {
          align-items: center;

          .rate {
            height: auto;
          }
        }
      }

      &.has-marks {
        align-items: flex-start;

        .method-name {
          align-items: flex-start;

          .rate {
            height: 44px;
          }
        }
      }

      .method-img {
        display: flex;
        justify-content: center;
        width: 44px;
        height: 44px;
        margin-right: 12px;
        border-radius: 5px;
        background: var(--pay-bg04, #f4f5f7);
        > img {
          width: 44px;
          object-fit: contain;
        }
      }
      .method-name {
        flex: 1;
        display: flex;
        justify-content: space-between;
        width: 100%;

        .method-info {
          flex: 1;
          min-width: 0;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex-direction: column;
          .name {
            font-family: var(--string-font);
            font-size: var(--fs-16);
            font-weight: var(--fw-500);
            line-height: var(--lh-label-20);
            color: var(--pay-color11, #333333);
          }
          .method-mark-container {
            margin-top: 3px;
            margin-left: -4px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .method-mark {
              margin-left: 4px;
              margin-bottom: 4px;
              padding: 3px 6px;
              border-radius: 2px;
              white-space: nowrap;
              flex-shrink: 0;

              font-family: var(--string-font);
              font-size: var(--fs-12);
              font-weight: var(--fw-500);
              line-height: var(--lh-label-20);

              &.discount {
                background: var(--pay-bg07);
                color: var(--pay-color17);
              }

              &.discount-first-use {
                background: var(--pay-bg09);
                color: var(--pay-color21);
              }

              &.last-used {
                background: var(--pay-bg10);
                color: var(--pay-color15);
              }

              &.most-favorable {
                background: var(--pay-bg11);
                color: var(--pay-color22);
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }

        .rate {
          display: flex;
          align-items: center;
          flex-shrink: 0;
          font-family: var(--number-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-500);
          color: var(--pay-color13, #333333);
          white-space: nowrap;
        }
      }
    }
  }
  .method-on {
    box-shadow: 0 0 0px 1.5px var(--pay-bg06, #a338fc) inset;
  }

  .method-tip-section {
    margin-top: -10px;
    padding-top: 10px;
    border-radius: 10px;
    background: var(--pay-bg08, #faedff);
    overflow: hidden;
    cursor: pointer;

    .tip-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 10px;

      .tip-title {
        color: var(--pay-color19, #6849a6);
        font-family: var(--number-font, 'InterTight-Regular');
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        flex: 1;
      }

      .tip-arrow {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
        background: var(--pay-icon01) top left / 100% 100% no-repeat;
        transform: rotateZ(0deg);
        transition: transform 0.2s ease;
        &.arrow-up {
          transform: rotateZ(180deg);
        }
      }
    }

    .tip-body {
      padding: 0 12px 10px 30px;
      color: var(--pay-color20, #6849a6);
      font-family: var(--number-font, 'InterTight-Regular');
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
      > div {
        margin-bottom: 6px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .submit-btn-block {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    background: var(--pay-bg05, rgba(249, 249, 251, 0.8));
    padding-top: 20px;

    .submit-btn {
      width: 335px;
      margin: auto;
      padding: 13px 20px;
      border-radius: var(--pay-radius01, 100px);
      background: var(--pay-bg06, #a338fc);
      font-family: var(--string-font);
      font-size: var(--fs-16);
      font-weight: var(--fw-400);
      line-height: var(--lh-title-20);
      font-style: normal;
      color: var(--pay-color14, #ffffff);
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 20px;
        margin: 0 3px;
      }
    }
  }
}

::v-deep .coupon-enter {
  margin-bottom: 20px;
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-pay .method-item .method-check {
    right: unset;
    left: 0;
  }
  .container-pay .method-item .method-con .method-img {
    margin-right: unset;
    margin-left: 12px;
  }
  .container-pay .method-item .method-check.checked {
    background: var(--pay-icon05) top left / 100% 100% no-repeat;
  }
}
</style>

<style>
.pay-coin-icon {
  width: 16px;
  height: 16px;
  margin: 0 1px;
}
</style>
